import { render, staticRenderFns } from "./Congres.vue?vue&type=template&id=05cb6ca0&scoped=true&"
import script from "./Congres.vue?vue&type=script&lang=js&"
export * from "./Congres.vue?vue&type=script&lang=js&"
import style0 from "./Congres.vue?vue&type=style&index=0&id=05cb6ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb6ca0",
  null
  
)

export default component.exports